export class Signed {
    courseId: string;
    subjectId: string;
    teacherId: string;
    type: string;
    signatureDate: string;
    timeBlockId: string;
}